// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__PknkC","label":"Labeled_label__HWEqv","divider":"Labeled_divider__2jwq6"};